const TYPE = "t"
const TYPE_DATE = "y"
const TYPE_DIRECTOR = "d"
const TYPE_WRITER = "w"
const TYPE_ACTOR = "a"
const TYPE_RATED = "r"
const TYPE_TAGGED = "t"
const TYPE_OWNED = "o"

const VALUE_QUALIFIER = "v"
const VALUE_QUALIFIER_PLUS = "+"
const VALUE_QUALIFIER_MINUS = "-"

const DATE_QUALIFIER = "d"
const DATE_QUALIFIER_BEFORE = "<"
const DATE_QUALIFIER_AFTER = ">"

const YEAR_VALUE = "Y"
const PERSON_VALUE = "P"
const RATING_VALUE = "R"
const USER_VALUE = "U"
const TAGGED_VALUE = "T"
const CATEGORY_VALUE = "C"

const NOT_FIELD = "not"
const NOT_VALUE = "Y"

export default {
  by: {
    type: "keyword",
    keyword: "by",
    action: "NONE",
    message: "Specify a certain user",
    priority: 5,
  },
  under: {
    type: "keyword",
    keyword: "under",
    action: "NONE",
    message: "Find films that have been tagged under the given category",
    priority: 5,
  },
  as: {
    type: "keyword",
    keyword: "as",
    action: "NONE",
    message: "Find films that have been tagged with the given tag",
    priority: 5,
  },
  plus: {
    type: "keyword",
    keyword: "plus",
    action: "SET",
    field: VALUE_QUALIFIER,
    value: VALUE_QUALIFIER_PLUS,
    message: "Change equality check to greater than or equal",
    priority: 6,
  },
  minus: {
    type: "keyword",
    keyword: "minus",
    action: "SET",
    field: VALUE_QUALIFIER,
    value: VALUE_QUALIFIER_MINUS,
    message: "Change equality check to lower than or equal",
    priority: 6,
  },
  made: {
    type: "keyword",
    keyword: "made",
    action: "SET",
    field: TYPE,
    value: TYPE_DATE,
    message: "Find films by the year they were made",
  },
  in: {
    type: "keyword",
    keyword: "in",
    action: "NONE",
    message: "Find films made in the given year",
  },
  after: {
    type: "keyword",
    keyword: "after",
    action: "SET",
    field: DATE_QUALIFIER,
    value: DATE_QUALIFIER_AFTER,
    message: "Find films made since the given year",
  },
  before: {
    type: "keyword",
    keyword: "before",
    action: "SET",
    field: DATE_QUALIFIER,
    value: DATE_QUALIFIER_BEFORE,
    message: "Find films made until the given year",
  },
  directed_by: {
    type: "keyword",
    keyword: "directed by",
    action: "SET",
    field: TYPE,
    value: TYPE_DIRECTOR,
    message: "Find films by their directors",
  },
  written_by: {
    type: "keyword",
    keyword: "written by",
    action: "SET",
    field: TYPE,
    value: TYPE_WRITER,
    message: "Find films by their writers",
  },
  starring: {
    type: "keyword",
    keyword: "starring",
    action: "SET",
    field: TYPE,
    value: TYPE_ACTOR,
    message: "Find films by their actors",
  },
  rated: {
    type: "keyword",
    keyword: "rated",
    action: "SET",
    field: TYPE,
    value: TYPE_RATED,
    message: "Find films by their ratings",
  },
  tagged: {
    type: "keyword",
    keyword: "tagged",
    action: "SET",
    field: TYPE,
    value: TYPE_TAGGED,
    message: "Find films using your tags and categories",
  },
  owned: {
    type: "keyword",
    keyword: "owned",
    action: "SET",
    field: TYPE,
    value: TYPE_OWNED,
    message: "Find films by their owners",
  },
  show_films: {
    type: "keyword",
    keyword: "show films",
    action: "INIT QUERY",
    message: "Start searching by Advanced Search",
  },
  that_are: {
    type: "keyword",
    keyword: "that are",
    action: "INIT THAT ARE",
    message: "Add another filtering with conjunction " +
             "('that are' has lower precedence than 'or')"
  },
  or: {
    type: "keyword",
    keyword: "or",
    action: "INIT OR",
    message: "Add another filtering with disjunction"
  },
  and: {
    type: "keyword",
    keyword: "and",
    action: "INIT AND",
    message: "Add another filtering with conjunction " +
             "('and' has higher precedence than 'or')"
  },
  not: {
    type: "keyword",
    keyword: "not",
    action: "SET",
    field: NOT_FIELD,
    value: NOT_VALUE,
    message: "Use a filter with negation"
  },
  year: {
    type: "value",
    name: "Year",
    matcher: /^\d{4}$/,
    extractor: /^\d{4}(?=\s|$)/,
    prefixer: /^\d{0,4}$/,
    field: YEAR_VALUE,
    prompt: "[Enter Year]",
    message: "4-digit year (click for help)",
    uiAction: "PICKER",
    uiIcon: "mdi-calendar-cursor",
  },
  person: {
    type: "value",
    name: "Person",
    matcher: /^[A-Z][A-Za-z-]*(?:\s*[A-Z][A-Za-z-]*)*$/,
    extractor: /^[A-Z][A-Za-z-]*(?:\s*[A-Z][A-Za-z-]*)*(?=\s|$)/,
    prefixer: /^[A-Z][A-Za-z-]*(?:\s*(?:[A-Z][A-Za-z-]*)?)*$/,
    field: PERSON_VALUE,
    prompt: "[Enter Person Name]",
    message: "Name, capitalized first letters (click for help)",
    uiAction: "PICKER",
    uiIcon: "mdi-account-supervisor",
  },
  rating: {
    type: "value",
    name: "Rating",
    matcher: /^(?:10|[0-9])$/,
    extractor: /^(?:10|[0-9])(?=\s|$)/,
    prefixer: /^(?:10|[0-9])$/,
    field: RATING_VALUE,
    prompt: "[Enter Rating]",
    message: "Whole number, 0 to 10, use 'plus' and 'minus' for ranges " +
             "(click for help)",
    uiAction: "PICKER",
    uiIcon: "mdi-star-half-full"
  },
  user: {
    type: "value",
    name: "User",
    matcher: /^[A-Za-z_]+$/,
    extractor: /^[A-Za-z_]+(?=\s|$)/,
    prefixer: /^[A-Za-z_]*$/,
    field: USER_VALUE,
    prompt:  "[Enter User Name]",
    message: "Username (click for help)",
    uiAction: "PICKER",
    uiIcon: "mdi-account",
  },
  tag: {
    type: "value",
    name: "Tag",
    matcher: /^[A-Za-z0-9_]+$/,
    extractor: /^[A-Za-z0-9_]+(?=\s|$)/,
    prefixer: /^[A-Za-z0-9_]*$/,
    field: TAGGED_VALUE,
    prompt: "[Enter Tag]",
    message: "Tag name, alphanumerical, no space (click for help)",
    uiAction: "PICKER",
    uiIcon: "mdi-tag",
  },
  cat: {
    type: "value",
    name: "Category",
    matcher: /^[A-Za-z0-9_]+$/,
    extractor: /^[A-Za-z0-9_]+(?=\s|$)/,
    prefixer: /^[A-Za-z0-9_]*$/,
    field: CATEGORY_VALUE,
    prompt: "[Enter Category]",
    message: "Category name, alphanumerical no space (click for help)",
    uiAction: "PICKER",
    uiIcon: "mdi-select-group",
  },
}
